import { WrenchIcon, XIcon } from "@phosphor-icons/react";
import dayjs from "dayjs";

import type { UsePurchaseBlockReturn } from "./tools/usePurchaseBlock";

interface DevToolsTriggerProps {
  isOpen: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  purchaseBlock: UsePurchaseBlockReturn;
}

export function DevToolsTrigger({
  isOpen,
  onClick,
  purchaseBlock: {
    isPurchaseAllowed,
    purchaseAllowedSecondsLeft,
    togglePurchaseBlock,
  },
}: DevToolsTriggerProps) {
  return (
    <div className="fixed right-2 bottom-2 z-100001 flex items-center gap-1">
      {isPurchaseAllowed && (
        <button
          type="button"
          onClick={togglePurchaseBlock}
          className="rounded-full border border-[var(--color-semantic-error-strong)] bg-surface-neutral-medium px-3 py-1 text-base text-[var(--color-semantic-error-strong)] shadow-2xl hover:bg-surface-neutral-medium"
        >
          {dayjs
            .duration(purchaseAllowedSecondsLeft, "seconds")
            .format("mm:ss")}
        </button>
      )}

      <button
        type="button"
        aria-label="DevTools"
        onClick={onClick}
        className="flex size-12 items-center justify-center rounded-full bg-surface-accent-strong shadow-2xl hover:bg-surface-accent-strong"
      >
        {isOpen ? (
          <XIcon className="text-white" size={20} />
        ) : (
          <WrenchIcon className="text-white" size={20} />
        )}
      </button>
    </div>
  );
}
